// Error reporting (A8), only when VITE_SENTRY_DSN is set: the SDK is a separate chunk, never loaded otherwise.
// No user data is attached (the SDK sends no PII by default; no replays, no tracing).

let report: ((e: unknown) => void) | null = null;

export async function initSentry(dsn: string | undefined = import.meta.env.VITE_SENTRY_DSN): Promise<void> {
  if (!dsn) return;
  const Sentry = await import('@sentry/react');
  Sentry.init({ dsn, tracesSampleRate: 0 });
  report = (e) => Sentry.captureException(e);
}

/** Reports an error if Sentry is on; a no-op otherwise. */
export const captureError = (e: unknown): void => report?.(e);
